import { Box, Stack, Tab, Tabs } from '@mui/material'
import { gql, useLazyQuery } from '@apollo/client'
import { useContext, useEffect, useMemo, useState } from 'react'
import { buildLink, GetPetProfile, Logger, Section, Typography } from '@wolfdanepug/common-react'
import { PawSolid } from '@wolfdanepug/icons'
import { ProfileImageManager } from '../../../components/ProfileImageManager'
import { Outlet, useNavigate } from 'react-router'
import { getProfileColor } from '../../../utils'
import { petProfileTabs } from '../../../constants'
import { useParams } from 'react-router'
import { PageContext } from '../../../context/page'

export default function PetLayout() {
	const { id }: any = useParams()
	const { setPage } = useContext(PageContext)
	const [activeTab, setActiveTab] = useState('info')

	const [fetchProfile, { data, loading }] = useLazyQuery(gql(GetPetProfile))

	useEffect(() => {
		Logger.log({ id })
		id && fetchProfile({ variables: { id } })
	}, [fetchProfile, id])

	const navigate = useNavigate()

	const tabs = useMemo(() => {
		if (!id) return []
		return petProfileTabs.map((tab: any, index: number) => ({
			...tab,
			linkTo: buildLink('pets', id, tab.linkTo)
		}))
	}, [id])

	const handleChange = (event: any, newValue: string) => {
		setActiveTab(newValue)
		// navigate(buildLink('pets', id, newValue === 'info' ? '' : newValue))
		navigate(buildLink('pets', id, newValue))
	}
	const profile = data?.getPetProfile

	useEffect(() => {
		setPage({
			title: `${profile?.name}'s Profile`,
			description: `Manage ${profile?.name}'s Profile`,
			// actions: [
			// 	{
			// 		label: 'Edit',
			// 		link: `/pets/${id}/edit`,
			// 		icon: <Edit />,
			// 		enabled: true
			// 	}
			// ],
			canGoBack: '/pets'
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [profile])

	if (loading) {
		return null
	}
	Logger.log({ profile, id, tabs })

	const profileColor = getProfileColor(0)

	return (
		<>
			<Section sx={styles.hero}>
				<Box sx={styles.content}>
					<Box sx={styles.imageWrap}>
						{profile && (
							<ProfileImageManager profile={profile} alt={`${profile?.name}'s Profile`} />
						)}

						<Stack
							sx={{
								flex: 1,
								flexDirection: 'row',
								gap: 2,
								alignItems: 'center',
								display: {
									xs: 'none',
									md: 'flex'
								}
							}}
						>
							<Box
								sx={{
									// float: 'left',
									display: 'inline-flex',
									// position: 'absolute',
									// bottom: 0,
									// left: '50%',
									// transform: 'translate(-50%, 60%)',
									// zIndex: 5,
									backgroundColor: profileColor,
									borderRadius: '50%',
									width: 45,
									height: 45,
									justifyContent: 'center',
									alignItems: 'center',
									// border: '3px solid #fff',
									color: '#fff'
								}}
							>
								<PawSolid />
							</Box>
							<Typography variant="h1" sx={styles.name}>
								{profile?.name}
							</Typography>
						</Stack>
					</Box>
				</Box>
			</Section>
			<Section>
				<Stack sx={{ width: '100%' }}>
					<Box>
						<Tabs value={activeTab} onChange={handleChange}>
							{tabs.map((tab: any, index: number) => (
								<Tab key={index} label={tab.label} value={tab.key} />
							))}
						</Tabs>
					</Box>
					<Box sx={{ minHeight: 300 }}>
						<Outlet context={{ profile }} />
					</Box>
				</Stack>
			</Section>
		</>
	)
}

const styles = {
	hero: {
		root: {
			height: {
				xs: 200,
				md: 400
			},
			mb: 15,
			position: 'relative'
		},
		overlay: {
			position: 'relative'
		},
		container: {
			// p: 3,
			position: 'relative',
			height: '100%',
			'&:before': {
				content: '""',
				position: 'absolute',
				background:
					'url(//static.wixstatic.com/media/294901_d3bd94722b794ea494de9285f1c2ff1b~mv2.jpg/v1/fill/w_1792,h_943,al_t,q_85,enc_auto/294901_d3bd94722b794ea494de9285f1c2ff1b~mv2.jpg) no-repeat center right',
				backgroundSize: 'cover',
				borderRadius: 2,
				overflow: 'hidden',
				top: 0,
				left: {
					xs: 16,
					md: 24
				},
				right: {
					xs: 16,
					md: 24
				},
				width: {
					xs: 'auto'
				},
				height: '100%'
			}
		},
		content: {
			height: '100%'
		}
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-end',
		height: '100%',
		width: {
			xs: '100%',
			md: 'auto'
		}
	},
	name: {
		width: 'auto'
	},
	imageWrap: {
		display: 'flex',
		gap: 3,
		transform: {
			xs: 'translate(0, 50%)',
			md: 'translate(30px, 30%)'
		},
		alignItems: {
			xs: 'center',
			md: 'flex-end'
		},
		flexDirection: {
			xs: 'column',
			md: 'row'
		}
	},
	image: {
		height: 200,
		width: 200
	}
}
